export default num => {
  if (!num) return '';
  if (num.toString().indexOf('.') !== -1) {
    return Number(num).toFixed(2);
  }
  return num;
};
